import * as XLSX from "xlsx";
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  Stack,
  Typography,
} from "@mui/material";
import CloseIcon from "assets/icons/CloseIcon";
import { CandidateResultData } from "../../types";
import CandidatesTable from "./components/Table";

export type CandidateResultModalProps = {
  data: CandidateResultData;
  open: boolean;
  onClose: () => void;
};

const CandidateResultModal = ({ data, open, onClose }: CandidateResultModalProps) => {
  const handleExport = () => {
    const worksheet = XLSX.utils.json_to_sheet(data);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Кандидаты");

    const excelBuffer = XLSX.write(workbook, { bookType: "xlsx", type: "array" });

    const dataBlob = new Blob([excelBuffer], { type: "application/octet-stream" });

    const url = window.URL.createObjectURL(dataBlob);
    const link = document.createElement("a");
    link.href = url;
    link.download = "Загруженные кандидаты.xlsx";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      fullWidth
      maxWidth='md'>
      <Stack
        justifyContent='space-between'
        alignItems='center'
        flexDirection='row'>
        <Box />
        <DialogTitle
          variant='h5'
          sx={{ fontWeight: 500, paddingBottom: 0 }}>
          Результат загрузки кандидатов
        </DialogTitle>
        <IconButton onClick={onClose}>
          <CloseIcon />
        </IconButton>
      </Stack>
      <DialogContent>
        <Typography
          textAlign='center'
          sx={{ marginBottom: 1 }}>
          Не забудьте сохранить данные - кандидаты могут использовать их для входа на платформу
        </Typography>
        <CandidatesTable data={data} />
      </DialogContent>
      <DialogActions>
        <Stack
          direction='row'
          spacing={2}>
          <Button
            variant='outlined'
            color='secondary'
            onClick={onClose}>
            Закрыть
          </Button>
          <Button
            onClick={handleExport}
            variant='contained'>
            Скачать
          </Button>
        </Stack>
      </DialogActions>
    </Dialog>
  );
};

export default CandidateResultModal;
